"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverError = void 0;
exports.serverError = {
    serverError_common_1: "Неизвестная ошибка",
    serverError_net_1: "Ошибка сети",
    serverError_auth_1: "Пользователь не найден",
    serverError_business_1: "У вас нет прав изменять чужой профиль",
    serverError_service_1: "Профиль специалиста не найден",
    serverError_service_2: "У вас нет прав изменять чужие услуги",
    serverError_client_1: "У вас нет прав изменять чужой профиль",
    serverError_contact_1: "Только специалисты могут добавлять или изменять контакты",
    serverError_contact_2: "У вас нет прав изменять чужой контакт",
    serverError_booking_1: "Услуга не найдена",
    serverError_booking_2: "Профиль специалиста не найден",
    serverError_booking_3: "Профиль клиента не найден",
    serverError_booking_4: "Невозможно создать запись",
    serverError_booking_5: "У вас нет прав изменять чужую запись",
    serverError_businessContact_1: "Профиль специалиста не найден",
    serverError_businessContact_2: "У вас нет прав изменять чужую контактную информацию",
    serverError_clientContact_1: "Профиль клиента не найден",
    serverError_clientContact_2: "У вас нет прав изменять чужую контактную информацию",
};
//# sourceMappingURL=serverError.js.map